import VueRouter, { Route } from 'vue-router'
import CONSTANTS from '@/constants'
import routes from './routes'
import store from '../store'

const Router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        selector: to.hash,
      }
    }
    return { x: 0, y: 0 }
  },
  routes,
})

Router.beforeResolve(async (to: Route, from: Route, next: Function) => {
  const isAuthenticated = store.state.auth.isAuthenticated

  if (
    isAuthenticated &&
    to?.name &&
    CONSTANTS.ROUTING_RULES.REDIRECT_IF_AUTHENTICATED.includes(to.name)
  ) {
    next({ name: 'home' })
  } else {
    next()
  }

  if (to?.name && CONSTANTS.ROUTING_RULES.DOORBELL_FEEDBACK.includes(to.name)) {
    if (window.doorbell) {
      window.doorbell?.setOption('hideButton', false)
      window.doorbell?.refresh()
    } else {
      setTimeout(() => {
        window.doorbell?.setOption('hideButton', false)
        window.doorbell?.refresh()
      }, 3000)
    }
  } else {
    if (window.doorbell) {
      window.doorbell?.setOption('hideButton', true)
      window.doorbell?.refresh()
    } else {
      setTimeout(() => {
        window.doorbell?.setOption('hideButton', true)
        window.doorbell?.refresh()
      }, 500)
    }
  }
})

export default Router
